import { useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { httpActions } from '@figure/frontlib-onboarding-redux';

/**
 * Repeats the onPoll function for the given internal and number of max attempts.  If the max number of attempts is reached, the user
 * is redirected to the timeout screen.
 *
 * @param {Function} onPoll - function that takes in the polling function as a parameter and is called for each poll
 * @param {Number} maxAttempts - (3) the maximum number of attempts to poll
 * @param {Number} interval - (2000) the interval in milliseconds to poll
 */
const usePollingTimeout = (onPoll, maxAttempts = 3, interval = 2000) => {
  const history = useHistory();
  const { uuid: appUuid } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    let timeoutId;

    const fetchUntilResponse = (attempts = 1) => () => {
      if (attempts > maxAttempts) {
        dispatch(httpActions.complete());
        return history.replace(`/applications/${appUuid}/review-app/in-review`);
      }

      timeoutId = setTimeout(() => onPoll(fetchUntilResponse(attempts + 1)), interval);
    };

    fetchUntilResponse()();

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
    };
  }, []);
};

export default usePollingTimeout;
